module.exports = __webpack_public_path__ + "img/40.6.CODm.f372ffe0.png";